import apiClient from './apiClient';

export interface FeedbackData {
  category: 'bug' | 'feature' | 'improvement' | 'other';
  subject: string;
  message: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  metadata?: {
    url?: string;
    userAgent?: string;
    screenshot?: string;
  };
}

export interface Feedback {
  id: string;
  user_id: string;
  category: string;
  subject: string;
  message: string;
  priority: string;
  status: 'pending' | 'in_progress' | 'resolved' | 'closed' | 'new';
  metadata?: Record<string, unknown>;
  admin_response?: string;
  created_at: string;
  updated_at: string;
}

type SubmitResponse = {
  success?: boolean;
  message?: string;
  feedback_id?: string;
} & Partial<Feedback>;

class FeedbackService {
  async submit(data: FeedbackData, recaptchaToken?: string): Promise<SubmitResponse> {
    const headers: Record<string, string> = {};
    if (recaptchaToken) {
      headers['X-Recaptcha-Token'] = recaptchaToken;
    }
    const response = await apiClient.api.post('/v1/feedback/submit', data, { headers });
    return response.data;
  }

  async getMyFeedback(): Promise<Feedback[]> {
    const response = await apiClient.api.get('/v1/feedback/my-feedback');
    const payload = response.data;
    return Array.isArray(payload) ? payload : payload?.data || [];
  }

  async getFeedbackById(id: string): Promise<Feedback> {
    const response = await apiClient.api.get(`/v1/feedback/${id}`);
    return response.data;
  }

  async updateFeedback(id: string, updates: Partial<FeedbackData>): Promise<Feedback> {
    const response = await apiClient.api.put(`/v1/feedback/${id}`, updates);
    return response.data;
  }

  async deleteFeedback(id: string): Promise<void> {
    await apiClient.api.delete(`/v1/feedback/${id}`);
  }
}

export const feedbackService = new FeedbackService();
